import { render, staticRenderFns } from "./GridPageEventOrganizers.vue?vue&type=template&id=1ba532d5&"
import script from "./GridPageEventOrganizers.vue?vue&type=script&lang=js&"
export * from "./GridPageEventOrganizers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba532d5')) {
      api.createRecord('1ba532d5', component.options)
    } else {
      api.reload('1ba532d5', component.options)
    }
    module.hot.accept("./GridPageEventOrganizers.vue?vue&type=template&id=1ba532d5&", function () {
      api.rerender('1ba532d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/eventOrganizers/grid/GridPageEventOrganizers.vue"
export default component.exports